import rootReducer from "./reducers";
import thunk from 'redux-thunk' //middleware
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { createStore, compose, applyMiddleware } from 'redux'

const persistConfig = {
    key: 'root',
    storage,
}
const persistedReducer = persistReducer(persistConfig, rootReducer)

let composeEnhancers = compose;

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
}

const configStore = () => {
    return createStore(persistedReducer, { }, composeEnhancers(applyMiddleware(thunk)));
};
let persistor = persistStore(configStore())

export { configStore, persistor }